<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M15.333,11.5002 C15.333,9.6772 13.841,8.2002 12,8.2002 C10.159,8.2002 8.666,9.6772 8.666,11.5002 C8.666,13.3222 10.159,14.8002 12,14.8002 C13.841,14.8002 15.333,13.3222 15.333,11.5002 M12,17.0002 C9.312,17.0002 7.07,15.1102 6.556,12.6002 L2,12.6002 L2,10.4002 L6.556,10.4002 C7.07,7.8892 9.312,6.0002 12,6.0002 C14.687,6.0002 16.93,7.8892 17.444,10.4002 L22,10.4002 L22,12.6002 L17.444,12.6002 C16.93,15.1102 14.687,17.0002 12,17.0002" id="path-path"></path>
      </defs>
      <g id="icons/path" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2-path" fill="white">
          <use xlink:href="#path-path"></use>
        </mask>
        <use id="Fill-1" :fill="fill" xlink:href="#path-path"></use>
        <g id="Mixin/Fill/Black" mask="url(#mask-2-path)" :fill="fill">
          <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsPathIcon',
  components: {
    Icon
  },
  props: {
    fill: {
      type: String,
      default: '#8b97ab'
    }
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-path-icon.vue